import React from 'react'
import { Grid, Typography, Divider, Paper, Box } from '@mui/material'
import '../../../styles/report.css'
import { Progress } from 'react-sweet-progress';
import {motion, AnimatePresence} from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "50",
    "ComponentType": "ADMIN KEY VALUE EXPANDED",
    "Visible": "1",
    "Label": "Top Health Conditions",
    "Sections": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "Heart Disease or Stroke",
            "HelpText": "",
            "Value": "0"
        }
    ]
}
*/

const KeyProgressCard = (props) => {
    const OrderedSections = [...props.component.ComponentValues].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredSections = OrderedSections.filter((a) => { return a.Visible === '1' })
    const EndListItems = props.component.EndList ?  props.component.EndList : []
    const OrderedEndListItems= [...EndListItems].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredEndListItems= OrderedEndListItems.filter((a) => { return a.Visible === '1' })

    const ProgressBar = ({ percent, status }) => {

        return (
            <Progress
                theme={{
                    success: {
                        symbol: <Typography variant="body2">{parseInt(percent,0)}%</Typography>,
                        color: '#4eb748'
                    },
                    default: {

                        color: '#E7C61E'
                    },
                    error: {

                        color: '#E6323A'
                    },
                    active: {

                        color: '#AEAEAE'
                    }
                }}
                percent={percent}
                status={status}
            />
        )

    }

    const DisplayItem = ({ displayValues }) => {
        return (
            <Box >
                <Grid container direction="row" alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                        <Typography variant="body2" align="right">{displayValues.Label}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <ProgressBar percent={Math.floor(parseInt(displayValues.Distribution || displayValues.Value,0))} status={'success'} />
                    </Grid>
                </Grid>
            </Box>
        )
    }


    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
          opacity: 1, x: 0, y: 0,
          transition: {
            delay: 0.1,
            duration: 0.5,
          }
        }
      }

    return (
        <motion.div variants={motionVariants} initial="hidden" animate="show" >

        
            <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px'}}>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="h5" align="center">{props.component.Label}</Typography>
                    </Grid>
                    <Grid item xs={12} m={1}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                    </Grid>
                    {
                        OrderedSections && OrderedSections.map((displayValues, index) => {

                            if(!displayValues.Distribution && !displayValues.Value) {return <></>}
                            return (
                                <Grid item xs={12}>
                                    <DisplayItem displayValues={displayValues} key={index} />
                                </Grid>
                            )

                        })
                    }
                    {
                        OrderedEndListItems && OrderedEndListItems.map((displayValues, index) => {

                            if(!displayValues.Distribution && !displayValues.Value) {return <></>}
                            return (
                                <Grid item xs={12}>
                                    <DisplayItem displayValues={displayValues} key={index} />
                                </Grid>
                            )

                        })
                    }
                    

                </Grid>
            </Paper>
            </motion.div>
        
    )
}

export default KeyProgressCard